<template>
    <label class="multiple-choice-option flex flex-align" :class="{checked, disabled, correct, incorrect}">
        <input class="checkbox-input" type="checkbox" :checked="checked" @input="toggle" :disabled="disabled" />
        <div class="ff">
            <div class="option-correct">Correct Response</div>
            <slot />
        </div>
    </label>
</template>

<script>
    export default {
        name: 'MultipleChoiceOption',
        data(){
            return {
                answerable: null
            };
        },
        props: {
            id: String,
            configuration: Object
        },
        mounted(){
            //TODO IMPORTANT I think we can switch this over to inject / provide.
            let parent = this.$parent;

            do {
                if(parent.$options._componentTag === 'multiple-choice'){
                    return this.answerable = parent;
                }
            } while(parent = parent.$parent);
        },
        computed: {
            checked(){
                if(!this.assignment){
                    //This is a chapter, and therefore a teacher is viewing this question.
                    return this.configuration.component_points;
                }

                if(this.answerable){
                    return this.answerable.selected === this.id;
                }

                return false;
            },
            assignment(){
                return this.$store.getters.assignment;
            },
            disabled(){
                if(this.assignment){
                    if(this.answerable){
                        if(this.answerable.complete){
                            return true;
                        }
                    }

                    return false; //TODO IMPORTANT
                    //What was I supposed to do here? It's not obvious...
                }

                return true;
            },
            correct(){
                if(this.answerable){
                    if(this.answerable.complete){
                        return this.configuration.component_points > 0;
                    }
                }

                return false;
            },
            incorrect(){
                if(this.answerable){
                    if(this.answerable.complete){
                        return this.configuration.component_points === 0;
                    }
                }

                return false;
            }
        },
        methods: {
            toggle(e){
                if(this.answerable){
                    this.answerable.$emit('select', e.target.checked ? this.id : '');
                }
            }
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .multiple-choice-option
    {
        border: 1px solid var(--input-border-color);
        border-left: 0;
        border-right: 0;
        padding: 10px 13px;
        margin: 0;
        cursor: pointer;
        user-select: none;
        margin: -1px 0 0;
        font-size: 14px;
        line-height: 18px;

        &:first-child
        {
            margin-top: 0;
        }

        &:focus-within, &:active
        {
            border-color: @base;
            box-shadow: 0 0 0 3px fade(@base, 30%);
            z-index: 3;
        }

        input.checkbox-input
        {
            background: var(--modal-background-color);
            margin-right: 15px;
            border: 0;
            transition: background-color ease 0.2s;

            &::after
            {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                content: "";
                background: url('~@/assets/icons/white/check.svg') 1px 3px no-repeat;
                background-size: 18px auto;
                transform: scale(0);
                transition: all ease 0.15s;
                opacity: 0;
            }

            &:checked
            {
                background: @base;

                &::after
                {
                    transform: scale(1);
                    opacity: 1;
                }
            }
        }

        &.disabled
        {
            pointer-events: none;
        }

        &.incorrect
        {
            input.checkbox-input:checked
            {
                background: @red;
            }
        }

        &.correct
        {
            input.checkbox-input:checked
            {
                background: @green;
            }

            .option-correct
            {
                display: block;
            }
        }
    }

    .option-correct
    {
        font-size: 11px;
        color: var(--primary-text-color);
        line-height: 14px;
        display: none;
        margin-bottom: 2px;
    }
</style>
